(function () {
    'use strict';
    angular.module('Directives').directive('bbaZoneInput', bbaZoneInput);
    bbaZoneInput.$inject = [
        'RoutingMatrixService',
        'toastr',
        '$filter'
    ];

    function bbaZoneInput(
        RoutingMatrixService,
        toastr,
        $filter
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bba-zone-input.html',
            require: ['^form', 'ngModel'],
            scope: {
                ngModel: '=',
                name: '=',
                required: '=?'
            },
            compile: bbaZoneInputCompile,
        };

        function bbaZoneInputCompile(tElement, tAttrs) {
            return {
                post: function ($scope, $element, $attrs, ngModels) {
                    $scope.searchResults = [];
                    $scope.searchLocations = searchLocations;
                    $scope.onSelect = onSelect;
                    $scope.isFormInvalid = isFormInvalid;
                    $scope.getErrorTooltip = getErrorTooltip;

                    function isFormInvalid() {
                        $scope.isInValid = (ngModels[1].$invalid && ngModels[1].$touched) || (ngModels[1].$invalid && ngModels[0].$submitted);
                        return $scope.isInValid;
                    }

                    function getErrorTooltip() {
                        if (!$scope.isInValid) { return; }
                        const name = $filter('bbaCapitalize')($scope.name.split('_').join(' '));
                        return `${name} is required`;
                        
                    }

                    function searchLocations(select) {
                        $scope.isLoading = true;
                        RoutingMatrixService.zones.getAll(success => {
                            $scope.searchResults = success.content;
                        }, error => {
                            toastr.error(error.message, 'Error');
                        }, { name: select.search });
                    }

                    function onSelect(selected) {
                        $scope.ngModel = selected;
                    }
                }
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/bbaZoneInput.js